export enum HintType {
    ICON = 'icon',
    ICON_LINK = 'icon_link',
    LINK = 'link'
}
